<template>
   <a-form ref='ruleForm' :rules="rules" :model='form' :labelCol="{span:5}" :wrapper-col="{span:19}">
       <a-form-item label="周期"  required :wrapper-col="{span:5}">
          <a-select v-model:value="form.number_type">
            <a-select-option :value="4">活动周期</a-select-option>
            <a-select-option :value="1">每天</a-select-option>
            <a-select-option :value="2">每周</a-select-option>
            <a-select-option :value="3">每月</a-select-option>
          </a-select>
       </a-form-item>
      <a-form-item label="累计扫码第" name='rule_mark_number' required >
          <!-- <a-radio-group lebel='用户' v-model:value="form.rule_mark_number">
            <a-radio :value="1"></a-radio>
          </a-radio-group>
          <br/> -->
          <p  v-for="(v,index) in form.number_arr"  :key="v">
              <a-input-number  style="width:200px" v-model:value="v.number" placeholder="(限1-1000的整数)" :precision="0" :min="1" :max="1000"></a-input-number> 次
              <MinusCircleOutlined @click="del(index)"  v-if='index !== 0' class="m-l-5"/>
          </p>
          <a-button @click="addNumber">添加</a-button>
      </a-form-item>
            <a-form-item :wrapper-col="{offset:10}">
         <a-button @click="submit"  type="primary">确定</a-button>
       </a-form-item>
   </a-form>
</template>

<script>
import { MinusCircleOutlined } from "@ant-design/icons-vue";
import { ref } from 'vue';
import { message } from 'ant-design-vue';
const rules={
  number_arr:[{required:true,message:'请选择周期'}],
  rule_mark_number:[{required:true,message:'请输入次数'}]
}
export default {
  components:{MinusCircleOutlined},
  setup(props,{emit}){
      const ruleForm=ref()
      const form=ref({number_arr:[{number:null}],rule_mark_number:1,number_type:4})
    
    const submit=()=>{
         ruleForm.value.validate().then(async(res)=>{
           var length=form.value.number_arr.filter(v=>v.number).length
           if(length!=form.value.number_arr.length){
             message.error('请输入完整次数')
             return
           }
          emit('ployDone',{
            rule_mark_number:1,
            index:form.value.index,
            number_type:form.value.number_type,
            number_arr:form.value.number_arr.map(v=>v.number)
          })
        }).catch(error=>error)
      }
      const del=(index)=>{
          form.value.number_arr.splice(index,1)
      }
      const addNumber=()=>{
        form.value.number_arr.push({number:''})
      }
      const inputNumber=(e)=>{
          console.log(e)
      }
      const renderDetail =(data,index)=>{
        form.value.number_arr=[]
        var number_arr=[]
        data.number_arr.forEach(element => {
           number_arr.push({
              number:element
            })
        });
       form.value=data
       form.value.index=index
       form.value.number_arr=number_arr
      }
      return{
        form,
        ruleForm,
        rules,
        addNumber,
        submit,
        inputNumber,
        del,
        renderDetail
      }
  }
}
</script>